import Popover from './_popover.js'
import Text from './_text.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Intent from './_intent.js'

export default {
  name: 'EarlyPayoutIndicator',
  values: {
    popover: {
      configSet: Popover,
      configValues: {},
    },
    text: {
      configSet: Text,
      configValues: {
        container: {
          padding: '2px 4px',
          whiteSpace: 'nowrap',
        },
      },
    },
    rulesContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '0 0 8px 0',
        },
      },
    },
    linkButton: {
      configSet: Button,
      configValues: {},
    },
    ruleText: {
      configSet: Text,
      configValues: {},
    },
    intent: {
      configSet: Intent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
